module.exports = new __parcel__URL__("link.4cfe7932.svg").toString();